import { colors, spacings } from "@/assets/themes";
import { CardBase } from "@/components/Styles/Base";
import { useFormikContext } from "formik";
import { Body14, Body16, List } from "../../components";
import Radio from "../../components/Radio";
import StepTitle from "../categoryForms/common/StepTitle";
import { StyledFormControl } from "../categoryForms/common/fields";
import { useFrequencyOptions } from "./get-frequency-options";

const FrequencySelection = ({ title }) => {
  const { values, setValues } = useFormikContext();
  const options = useFrequencyOptions();

  const handleSelection = (frequency) => {
    setValues((v) => ({
      ...v,
      frequency,
      wposition: undefined,
      ...options.find((option) => option.id === frequency).values,
    }));
  };

  return (
    <>
      <StepTitle>{title}</StepTitle>
      <StyledFormControl>
        <CardBase
          border
          flat
          css={`
            padding-top: ${spacings.xs};
            padding-bottom: ${spacings.xs};
          `}
        >
          <List.Group>
            {options.map((option) => (
              <List.Item
                key={option.id}
                withGutters
                onClick={() => handleSelection(option.id)}
                RightComponent={() => (
                  <Radio checked={values.frequency === option.id} />
                )}
              >
                <Body16>{option.title}</Body16>
                <Body14 color={colors.muted}>{option.subtitle}</Body14>
              </List.Item>
            ))}
          </List.Group>
        </CardBase>
      </StyledFormControl>
    </>
  );
};

export default FrequencySelection;
